<template>
  <div class="container-table-striped">
    <div class="table-hover">
      <table class="table content-table-striped table-striped mb-5">
        <thead>
          <tr class="row global-thead-dark thead-property pl-1">
            <th class="col-4">
              Documento
            </th>
            <th class="col-4">
              Archivo
            </th>
            <th class="col-4" />
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" :key="'pdd' + index" class="row">
            <td class="col ml-4">
              <span>{{ item.document }}</span>
            </td>
            <td class="col">
              <span>{{ item.file }}</span>
            </td>
            <td class="col">
              <div class="dropdown mt-0">
                <button
                  id="dropdownMenuButton"
                  class="btn btn-dropdown-actions dropdown-toggle float-right pt-1"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  :disabled="disabled"
                >
                  Acciones
                </button>
                <div
                  class="dropdown-menu"
                  aria-labelledby="dropdownMenuButton"
                  :disabled="disabled"
                >
                  <a class="dropdown-item" href="#">
                    <i class="fas fa-edit text-green" />
                    Editar
                  </a>
                  <a
                    class="dropdown-item cursor-pointer"
                    @click="deleteItem(index)"
                  >
                    <i class="fas fa-times-circle text-red" />
                    Eliminar
                  </a>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td v-if="items.length == 0" class="p-0 m-0 box-container mt-n3">
              <div v-if="!isAddMode" class="col-12 text-center p-4">
                <button
                  class="btn bg-light-white w-50 pt-1 mt-2 button-add"
                  :disabled="disabled"
                  @click="addDocument"
                >
                  <i class="fas fa-file-plus pr-4 text-green" />
                  <span class="text-button-add-document pt-4">
                    Presione aquí para solicitud de referidos
                  </span>
                </button>
              </div>
              <div class="ml-2 mr-2 mt-4" :disabled="disabled">
                <ProcessDeterminationDocumentAdd
                  v-if="isAddMode"
                  @on-add="onAddHandler"
                />
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import ProcessDeterminationDocumentAdd from './ProcessDeterminationDocumentAdd';
export default {
  name: 'ProcessDeterminationDocument',
  data() {
    return {
      items: [],
      isAddMode: false,
    };
  },
  methods: {
    addDocument() {
      this.isAddMode = true;
    },
    deleteItem(index) {
      this.items.splice(index, 1);
    },
    onAddHandler() {
      this.items.push({
        document: 'Respaldo',
        file: 'Determinación_doc.pdf',
      });
      this.isAddMode = false;
    },
  },
  props: {
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    ProcessDeterminationDocumentAdd,
  },
};
</script>

<style scoped>
.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.box-container {
  background: #fafbfa 0% 0% no-repeat padding-box;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}

.drop-item:hover {
  text-decoration: none;
  color: #727272;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}
</style>
